import { getLoggedUserClaims, getLoggedUserFullName, converObjectToBlob } from 'utils';
import { format } from 'date-fns';

export const getPayload = ({ order = [], catalogCode, catalogServiceId, uploadedFiles = [] }) => {
    const userClaims = getLoggedUserClaims();
    const getEndpoint = (endpoint) => {
        return {
            ...(endpoint?.sourceResource && {
                sourceResource: {
                    resourceType: endpoint?.sourceResource?.resourceType,
                    resourceTypeDisplayName: endpoint?.sourceResource?.resourceTypeDisplayName,
                    resourceName: endpoint?.sourceResource?.resourceName,
                    subscription: endpoint?.sourceResource?.subscriptionId,
                    subscriptionName: endpoint?.sourceResource?.subscription,
                    location: endpoint?.sourceResource?.location,
                    resourceGroup: endpoint?.sourceResource?.resourceGroup,
                    resourceId: endpoint?.sourceResource?.resourceId,
                    environment: endpoint?.sourceResource?.environment,
                },
            }),
            ...(endpoint?.targetResource && {
                targetResource: {
                    resourceType: endpoint?.targetResource.resourceType,
                    resourceTypeDisplayName: endpoint?.targetResource?.resourceTypeDisplayName,
                    resourceName: endpoint?.targetResource.resourceName,
                    subscription: endpoint?.targetResource.subscriptionId,
                    subscriptionName: endpoint?.targetResource?.subscription,
                    resourceGroup: endpoint?.targetResource.resourceGroup,
                    location: endpoint?.targetResource.location,
                    resourceSubType: endpoint?.targetResource?.resourceSubType,
                    resourceId: endpoint?.targetResource?.resourceId,
                    environment: endpoint?.targetResource.environment,
                },
            }),
        };
    };
    const payload = {
        requestorGpid: userClaims?.accessToken?.claims?.gpid,
        applicationOwnerId: order?.appOwnerDetails?.gpid,
        entityDetails: {
            name: order?.appProfile,
            // applicationManager: order?.entityDetails?.owner?.name,
            // applicationManagerEmail: order?.entityDetails?.owner?.emailId,
            // applicationManagerGpid: order?.entityDetails?.owner?.id,
            sector: order?.entityDetails?.sector || null,
        },
        estimatedCosts: order?.estimatedCost,
        catalogServices: order.instanceDetails.map((instanceDetail) => ({
            ...(catalogServiceId && { catalogServiceId }),
            cloudProvider: order?.cloudProvider,
            cloudService: order?.cloudService,
            catalogServiceCode: catalogCode,
            catalogType: order?.catalogType,
            sector: order?.sector,
            estimatedCost: order?.initCost,
            quantity: 1,
            catalogConfig: {
                name: order?.appProfile,
                sector: order?.sector,
                costCenter: order?.hCodeDetails?.label,
                billingEntity: order?.billingEntity || null,
                dataClassification: order?.dataClassification || null,
                dlApprovalEmail: order?.dlApprovalEmail || null,
                privateEndpointType: instanceDetail?.privateEndpointType === 'Enterprise PE' ? 'enterprise' : 'isolated',
                ...getEndpoint(instanceDetail),
                type: catalogCode,
                ...(order?.enabledManualBudgetCode && { enabledManualBudgetCode: order?.enabledManualBudgetCode }),
                tags: {
                    Environment: instanceDetail?.sourceResource?.environment || instanceDetail?.targetResource?.environment,
                    Servicename: order?.appProfile,
                    Provisioneddate: format(new Date(), 'yyyy-MM-dd'),
                    Requestedby: getLoggedUserFullName(),
                    'pep-business-category': order?.businessCategory,
                    'pep-dataclassification': order?.dataClassification,
                },
            },
        })),
    };
    const newPayload = {
        ...payload,
        ...(order?.orderId && {
            deletedFiles: order?.deletedFiles || [],
        }),
    };
    const formData = new FormData();
    const blobPayload = converObjectToBlob(newPayload);
    formData.append('orderDto', blobPayload);
    if (uploadedFiles && uploadedFiles?.length) {
        uploadedFiles?.forEach((file) => {
            if (!order?.id) {
                formData.append('files', file);
            }
            if (!file?.blobRelativeLink && order?.id) {
                formData.append('files', file);
            }
        });
    }
    if (uploadedFiles?.every((file) => file?.blobRelativeLink)) {
        formData.append('files', new Blob([''], { type: 'application/octet-stream' }), '');
    }
    return formData;
};
export default getPayload;
